<template>
  <div
    v-click-outside="() => ui.showList = false"
    :class="ui.showList && 'active'"
    class="dropdown-select"
  >
    <div
      class="dropdown-select__value"
      @click="ui.showList = !ui.showList"
    >
      <span
        :class="selected.length > 0 && 'dropdown-select__selected--number'"
        class="dropdown-select__selected"
      >
        {{ selected.length > 0 ? selected.length : 'Selecione' }}
      </span>

      <i
        :class="ui.showList && 'dropdown-select__arrow--inverted'"
        class="icon icon-arrow-down dropdown-select__arrow"
      />
    </div>

    <transition name="fade">
      <ul
        v-if="ui.showList"
        class="dropdown-select__list"
      >
        <li
          v-for="(item, index) in options"
          :key="`${id}_item_${index}`"
          :class="selected.includes(item.value) && 'dropdown-select__list-item--checked'"
          class="dropdown-select__list-item"
          @click.prevent="checkOption(item.value, selected)"
        >
          <span>{{ item.label }}</span>

          <span v-show="selected.includes(item.value)">
            <i class="icon icon-check" />
          </span>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'DrSelectList',

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: {
      type: Array,
      required: true
    },

    options: {
      type: Array,
      required: true
    },

    id: {
      type: String,
      required: false,
      default: () => 'drselectlist_'
    }
  },

  data () {
    return {
      finalSelected: null,
      selected: [],
      ui: {
        showList: false
      }
    }
  },

  watch: {
    'ui.showList': {
      deep: true,
      immediate: false,
      handler (next, prev) {
        if (next !== prev && !next && prev) {
          this.finalSelected = [...this.selected]
        }
      }
    },

    finalSelected: {
      deep: true,
      immediate: false,
      handler (next, prev) {
        if (JSON.stringify(next) !== JSON.stringify(prev)) {
          this.$emit('input', next)
        }
      }
    }
  },

  methods: {
    checkOption (item, list) {
      if (list.includes(item)) {
        list.splice(list.indexOf(item), 1)
      } else {
        list.push(item)
      }
    }
  }
}
</script>
